import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';

import './index.scss';

const ToolTip = ({ icon, header, text }) => {
  const [show, setShow] = useState(false);
  const [isTopHalfOfScreen, setIsTopHalfOfScreen] = useState(true);
  const iconRef = useRef(null);
  const textRef = useRef(null);

  const handleToolTipPosition = () => {
    let tooltipPosition;
    let height;
    if (iconRef?.current) {
      height = window?.innerHeight / 3.5;
      tooltipPosition = iconRef?.current?.getBoundingClientRect().y;
      if (tooltipPosition < height) setIsTopHalfOfScreen(true);
      else if (tooltipPosition > height) setIsTopHalfOfScreen(false);
    }
  };

  const handleScroll = () => handleToolTipPosition();

  const handleShow = () => {
    setShow(!show);
    handleToolTipPosition();
  };

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [show, isTopHalfOfScreen]);

  return (
    <button
      data-testid="icon-button"
      type="button"
      className="tool-tip-container"
      onClick={handleShow}
    >
      <div ref={iconRef} className="tool-tip-icon">
        {icon}
      </div>
      {show && (
        <div
          data-testid="tooltip-text"
          ref={textRef}
          className={`tool-tip-text ${isTopHalfOfScreen ? 'tool-tip-above' : 'tool-tip-below'}`}
          style={{
            bottom: isTopHalfOfScreen ? `-${textRef?.current?.clientHeight + 15}px` : '30px',
          }}
        >
          <button className="tool-tip-close" onClick={handleClose}>
            ×
          </button>
          {header && <strong>{header}</strong>}
          <p dangerouslySetInnerHTML={{ __html: text }} />
          <div
            className={`tool-tip-triangle ${
              isTopHalfOfScreen ? 'tool-tip-triangle-above' : 'tool-tip-triangle-below'
            }`}
          />
        </div>
      )}
    </button>
  );
};

ToolTip.propTypes = {
  icon: PropTypes.node.isRequired,
  header: PropTypes.string,
  text: PropTypes.string.isRequired,
};

ToolTip.defaultProps = {
  header: '',
};

export default ToolTip;
